<style>
.el-input__inner {
    border: 1px solid #BBBABA;
    border-radius: 10px;
    height: 36px;
}

.el-select {
    width: 174px;
}

.el-range-editor.el-input__inner {
    width: 240px;
}

.choose {
    display: flex;
    justify-content: space-between;
}

.choose ul {
    display: flex;
    gap: 20px;
}

.export_png {
    display: block;
    line-height: initial;
    max-width: 160px;
    padding: 14px 10px;
    width: 100%;
    border-radius: 10px;
    color: #FFFFFF;
    text-align: center;
    font-size: 12px;
    font-weight: 900;
    box-sizing: border-box;
    text-decoration: none;
    background: #006BFF;
    font-family: 'Conv_AvenirLTStd-Black-1';
    white-space: nowrap;
}

.el-tabs__item {
    width: 140px;
    text-align: center;
    font-size: 20px;
    font-weight: 900;
    padding: 0;
}

.el-tabs__active-bar {
    height: 3px;
    background-color: #006BFF;
}

.el-tabs__item.is-active {
    color: #006BFF;
}

.Level_three {
    width: 100%;
    border-bottom: 1px solid #EEE;
    padding-top: 28px;
}

.Level_three ul {
    display: flex;
    gap: 20px;
}

.Level_three ul li {
    width: 140px;
    text-align: center;
    font-size: 20px;
    font-weight: 900;

}

.Level_three ul li a {
    color: #898787;
    display: block;
    width: 100%;
    height: 100%;
    padding-bottom: 6px;
}

.activea {
    border-bottom: 3px solid #006BFF;

}

.activea a {
    color: #006BFF !important;
}
</style>
<template>
    <div class="Dashboard">
        <div class="choose">
            <ul>
                <li>
                    <el-date-picker v-model="lasting" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                        placeholder="Select date">
                    </el-date-picker>
                </li>
                
                <li class="dashbord_days">
                    <el-input v-model="days" placeholder="days"></el-input>
                </li>
                <li>
                    <el-select v-model="timeUnit" placeholder="请选择">
                        <el-option v-for="item in timeUnit_options" :key="item.value" :label="item.label"
                            :value="item.value"> 
                        </el-option>
                    </el-select>
                </li>
                <!-- <li>
                    <el-select v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </li> -->
            </ul>
            <a href="javascript:;" @click="clickGeneratePicture()" class="export_png">Export to PNG</a>
        </div>
        <div class="Level_three">
            <ul>
                <li v-for="(item, index) in rourer_link" :key="index" @click=" Trendea(index)">
                    <router-link :to="item.url">
                        <span>{{ item.name }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="container" ref="imageDom">
            <router-view></router-view>
        </div>

    </div>

</template>
<script>
import html2canvas from "html2canvas"
import $ from 'jquery'
import FileSaver from 'file-saver'
export default {
    data () {
        return {
            rourer_link: [
                { name: "Users", url: "/Dashboard/Users" },
                { name: "Deposit", url: "/Dashboard/Deposit" },
                { name: "Account Type", url: "/Dashboard/Account_Type" },
                { name: "Traffic", url: "/Dashboard/Traffic" },
            ],
            timeUnit: 'day',
            timeUnit_options: [{
                value: 'day',
                label: 'day'
            }, {
                value: 'week',
                label: 'week'
            }, {
                value: 'month',
                label: 'month'
            },],
            options: [{
                value: '选项1',
                label: 'day'
            },],
            days: '3',
            lasting: "2023-03-25",
            activeName: 'second',
            Cookies_Users: 0,
            value: '',
            imgUrl: '',//获取的base6464
            imgSrc: '',//转换的图片信息
        }
    },
    watch: {
        'lasting' (oldval) {
            if (oldval != '') {
                sessionStorage.setItem("lasting", this.lasting)
            }
        },
        'days' (oldval) {
            if (oldval != '') {
                sessionStorage.setItem("days", this.days)
            }
        },
        'timeUnit' (oldval) {
            if (oldval != '') {
                sessionStorage.setItem("timeUnit", this.timeUnit)
            }
        },
    },
    mounted () {
        sessionStorage.setItem("lasting", this.lasting)
        sessionStorage.setItem("days", this.days)
        sessionStorage.setItem("timeUnit", this.timeUnit)

        this.lasting = sessionStorage.getItem("lasting")
        this.days = sessionStorage.getItem("days")
        this.timeUnit = sessionStorage.getItem("timeUnit")


        this.Cookies_Users = sessionStorage.getItem("Cookies_Users")
        
        if (this.Cookies_Users != "undefined") {
            $(".Level_three ul li span").eq(this.Cookies_Users).parent().parent().addClass("activea").siblings().removeClass("activea")
        } else {
            $(".Level_three ul li span").eq(0).parent().parent().addClass("activea").siblings().removeClass("activea")
        }

    },
    methods: {
        clickGeneratePicture () {
            let savename = new Date().toLocaleTimeString()
            html2canvas(this.$refs.imageDom).then(canvas => {
                let saveUrl = canvas.toDataURL('image/png')
                let aLink = document.createElement('a')
                let blob = this.base64ToBlob(saveUrl)
                let evt = document.createEvent('HTMLEvents')
                evt.initEvent('click', true, true)
                aLink.download = savename
                aLink.href = URL.createObjectURL(blob)
                aLink.click()
                // console.log(aLink.href)
                if (aLink.href) {
                    var Toast = Toast.success('保存成功')
                }
            })
        },
        onSaveImage () {
            let image = new Image()
            image.src = this.imgSrc
            let canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            let ctx = canvas.getContext('2d')
            ctx.drawImage(image, 0, 0)
            canvas.toBlob(function (blob) {
                FileSaver.saveAs(blob, 'image.png')
            })
        },
        base64ToBlob (code) {
            let parts = code.split(';base64,')
            let contentType = parts[0].split(':')[1]
            let raw = window.atob(parts[1])
            let rawLength = raw.length
            let uInt8Array = new Uint8Array(rawLength)
            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }
            return new Blob([uInt8Array], { type: contentType })
        },
        Trendea (e) {
            $(".Level_three ul li span").eq(e).parent().parent().addClass("activea").siblings().removeClass("activea")
            sessionStorage.setItem("Cookies_Users", e)
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/views/Dashboard.vue